import Splide from '@splidejs/splide';

class CarouselSplide {
  constructor(element) {
    this.element = element;
    this.slider = null;
    this.pagination = null;

    this.init();
  }

  init() {
    this.slider = new Splide(this.element, {
      type   : 'loop',
      arrows: true,
      arrowPath: 'M13.8,33.3c-.2,0-.4,0-.6-.2-.3-.3-.3-.8,0-1.2l11.9-11.9-11.9-11.9c-.3-.3-.3-.8,0-1.2s.8-.3,1.2,0l12.4,12.5c.3.3.3.8,0,1.2l-12.4,12.5c-.2.2-.4.2-.6.2Z',
      pagination: false,
      lazyLoad: 'nearby',
      keyboard: 'focused',
      preloadPages: 2,
      mediaQuery: 'min',
      gap: '.8rem',
      // fluid, water-like motion
      speed: 700,
      rewindSpeed: 900, // loop-type doesn't strictly need this, but harmless if you switch type later
      easing: 'cubic-bezier(0.45, 0, 0.15, 1)',
      breakpoints: {
        768: {
          gap: '2.4rem',
        },
      }
    } );

    this.createPagination();

    this.slider.on('mounted move', () => {
      this.updatePagination();
    });

    this.slider.mount();

  }

  createPagination() {
    this.pagination = document.createElement('div');
    this.pagination.className = 'splide__pagination-counter body-sm';
    this.pagination.setAttribute('aria-live', 'polite');

    this.element.appendChild(this.pagination);
  }

  updatePagination() {
    if (!this.pagination) {
      return;
    }

    const current = this.slider.index + 1;
    const total = this.slider.length;

    this.pagination.textContent = `${current} / ${total}`;
  }

}

export default CarouselSplide
